/* eslint-disable no-unused-vars */
import jsPDF from "jspdf";
import {
  formatarData,
  obterHoraFormatada,
  obterDataFormatada,
} from "@/components/generators/utils";
import imgCabecalho from "@/core/assets/img/cabecalhos-pdf/senado-bt.jpeg";

export function geradorDePdf(dado, caseType) {

  const generateData = () => {
    const result = [];

    result.push({
      "UNIDADE ADM.":
        dado.departamento.sigla + " - " + dado.departamento.descricao,
      "LOGIN USUÁRIO": dado.pessoa.usuario.login,
      SITUAÇÃO: dado.situacaoBem === 1 ? "Ativo" : "Inativo",
      ID: dado.id.toString(),
      "DESCRIÇÃO BEM": dado.descricao,
      DATA: formatarData(dado.dhCriacao),
    });

    return result;
  };

  const createHeaders = (keys) => {
    const result = [];
    for (let i = 0; i < keys.length; i += 1) {
      result.push({
        id: keys[i],
        name: keys[i],
        prompt: keys[i],
        width:
          (keys[i] === "UNIDADE ADM." && 120) ||
          (keys[i] === "LOGIN USUÁRIO" && 45) ||
          (keys[i] === "SITUAÇÃO" && 40) ||
          (keys[i] === "ID" && 35) ||
          (keys[i] === "DESCRIÇÃO BEM" && 50) ||
          70,
        align: "center",
        padding: 0,
      });
    }
    return result;
  };

  const headers = createHeaders([
    "UNIDADE ADM.",
    "LOGIN USUÁRIO",
    "SITUAÇÃO",
    "ID",
    "DESCRIÇÃO BEM",
    "DATA",
  ]);

  const doc = new jsPDF({
    putOnlyUsedFonts: true,
    orientation: "landscape",
  });

  doc.addImage(imgCabecalho, "JPEG", 8, 10, 90, 12);
  doc.setFontSize(12);
  doc.text(
    "Emitido no dia " + obterDataFormatada() + " as " + obterHoraFormatada(),
    283,
    17,
    null,
    null,
    "right"
  );
  doc.setFontSize(10);

  doc.text("Página 1 / 1", 283, 22, null, null, "right");

  doc.setFontSize(11);
  doc.setFont("", "bold");
  doc.text("SITUAÇÃO LOGIN", 10, 40, null, null, "left");
  doc.text("UNIDADE ADM.", 10, 44, null, null, "left");
  doc.text("SITUAÇÃO BEM", 10, 48, null, null, "left");

  doc.setFontSize(11);
  doc.setFont("", "normal");

  doc.text(
    `: ${dado.departamento.sigla} - ${dado.departamento.descricao}`,
    45,
    40,
    null,
    null,
    "left"
  );
  doc.text(`: ${dado.pessoa.situacao}`, 40, 44, null, null, "left");
  doc.text(
    `: ${dado.situacaoBem === 1 ? "Ativo" : "Inativo"}`,
    42,
    48,
    null,
    null,
    "left"
  );

  doc.table(10, 50, generateData(), headers);

  doc.save(`Relatorio do dia ${obterDataFormatada(true)}`);
}
